define(function (require) {
    "use strict";

	var LE = require("app");
    var Media = require("media");
    var Page = require("ui.components/page/Page");
    var Dialog = require("ui/dialog/Dialog");

    var ContentSystemTablePageModel = require("content-models/system/ContentSystemTablePageModel");
    var Constant = require("content-config/constant.json");

    var ContentSystemTableLayout = require("content-views/content-gallery/system/ContentSystemTableLayout");
    var ContentSystemTableView = require("content-views/content-gallery/system/ContentSystemTableView");

    var ContentGalleryComparators = require("content-comparators/ContentGalleryComparators");
    var ContentGalleryFilters = require("content-filters/ContentGalleryFilters");

    var ContentSystemTableController = {};

    var ROUTE_BASE = Constant.ROUTE_BASE;


    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {
        ContentSystemTableController = Marionette.Controller.extend({
            isAcUser: null,
            tableLayout: null,
            contentSystemTableView: null,

            //------------------------------------------------------------------------
            // initialize
            //------------------------------------------------------------------------
            initialize:function (options) {
                this._initialize(options);

            },
            prepData: function(){
                 this._prepData();
            },
            getMainView: function() {
                return this.tableLayout;
            },
            onNavigateOut: function(){
                this._onNavigateOut();
            },
            getPageModel: function() {
                return this.model;
            },
            getPath: function() {
                return ROUTE_BASE[this.type];
            },
            onClose: function () {
                LEContent.logger.info("closing", "ContentSystemTableController:close");
                this.channel.reset();
                this.tableLayout.close();
            },

            //------------------------------------------------------------------------
            _initialize: function (options) {
                LEContent.logger.info ("initializing","ContentSystemTableController:initialize");
                this.type = options.type;
                this.channel = LEContent.media.channel("ContentSystemTableController" + this.type);
                this.isAcUser = LE.siteSettings.accountSettings.isAcUser();
                this.model = new ContentSystemTablePageModel({type: this.type});
                this._prepareViews();
                this._bindEvents();
            },
            _prepareViews: function(){
                this.tableLayout = new ContentSystemTableLayout({
                    channel: this.channel,
                    model: this.model,
                    isAcUser: this.isAcUser
                });

                this._createTableView();

                //the context of the callback will be this (this controller)
                this.listenTo(this.tableLayout, "render", function () {
                    LEContent.logger.info("onRender of layout called showing all contentGallery regions","ContentSystemTableController:initViews");
                    //when the layout is rendered, we"ll setup the inner regions
                    this.tableLayout.tableRegion.show(this.contentSystemTableView);

                },this);
            },

            _createTableView: function() {
                this.contentSystemTableView = new ContentSystemTableView({
                    channel:        this.channel,
                    type:        this.type,
                    model:       this.model.getGridViewModel(),
                    collection:  this.model.getOrganizedCollection(),
                    comparators: ContentGalleryComparators,
                    filters:     ContentGalleryFilters,
                    isAcUser:    this.isAcUser
                });
            },

            //------------------------------------------------------------------------

            _bindEvents: function(){
                //table
                this.listenTo(this.channel,"contentSystemGalleryTable:editItem",this._editItem);
                this.listenTo(this.channel,"contentSystemGalleryTable:selectClicked",this._selectItem);
                //actions
                this.listenTo(this.channel, "contentSystemTableLayout:actions:edit", this._editItem, this);
            },
            //------------------------------------------------------------------------
            // editItem
            //------------------------------------------------------------------------

            _editItem:function(options){
                var model = {};
                if (_.isObject(options)) {
                    model = options.model;
                } else { //no item id take selected item from collection
                    model = this.model.getCollection().getSelectedModel();
                }

                LEContent.router.navigate(this.getPath() + "/"+ model.getID());
            },
            _selectItem: function (options) {
                if (options.select) {
                    this.model.getCollection().addToSelection(options.model, {exclusively: true});
                } else {
                    this.model.getCollection().deselectModel(options.model);
                }

            },
            _prepData: function () {
                this.model.prepData();
            }

        });
    });

    return  ContentSystemTableController;
});
